export default {
  ERROR: 'Ocurrio un error, lo sentimos',
};
